import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { useHttpClient } from "contexts/httpClient";
import { getStorageRegions } from "apis/storage-regions.apis";
import { genericErrorMessage, QUERIES } from "consts";
import { showAlert } from "slices/alertsSlice";
import {
  TProductStorageRegion,
  TStorageProvider,
} from "types/apis/storage-regions.types";
import { QueryConfigType } from "types/query";

export const useStorageRegions = (
  config: QueryConfigType<TProductStorageRegion[]>
) => {
  const dispatch = useDispatch();
  const httpClient = useHttpClient();

  const queryOptions: typeof config = {
    staleTime: Infinity,
    ...config,
    onError: (e) => {
      config?.onError?.(e);
      dispatch(
        showAlert({
          message: e?.message || genericErrorMessage,
          type: "danger",
        })
      );
    },
  };

  return useQuery(
    [QUERIES.getStorageRegionsList],
    () => getStorageRegions({ httpClient }),
    queryOptions
  );
};

export const useStorageRegionsDropdownOptions = ({
  productID,
  storageProvider,
}: {
  productID?: 1 | 2;
  storageProvider: TStorageProvider;
}) => {
  return useStorageRegions({
    select: (data) => {
      if (!productID) {
        return data
          .map((product) => product.regions)
          .flat()
          .filter((region) => region.storageProvider === storageProvider)
          .map((region) => ({
            label: region.name,
            value: region.name,
          }));
      }

      return data
        .find((product) => product.productID === productID)
        ?.regions.filter((region) => region.storageProvider === storageProvider)
        .map((region) => ({
          label: region.name,
          value: region.name,
        }));
    },
  });
};
